<template>
  <b-card>
    <FormBuilder
      label="Brand"
      create
      :fields="fields"
      :loading-submit="$store.state.brand.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/brand'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('brand/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
